"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfReportBrokenLinkDto = instanceOfReportBrokenLinkDto;
exports.ReportBrokenLinkDtoFromJSON = ReportBrokenLinkDtoFromJSON;
exports.ReportBrokenLinkDtoFromJSONTyped = ReportBrokenLinkDtoFromJSONTyped;
exports.ReportBrokenLinkDtoToJSON = ReportBrokenLinkDtoToJSON;
exports.ReportBrokenLinkDtoToJSONTyped = ReportBrokenLinkDtoToJSONTyped;
/**
 * Check if a given object implements the ReportBrokenLinkDto interface.
 */
function instanceOfReportBrokenLinkDto(value) {
    if (!('brokenLink' in value) || value['brokenLink'] === undefined)
        return false;
    return true;
}
function ReportBrokenLinkDtoFromJSON(json) {
    return ReportBrokenLinkDtoFromJSONTyped(json, false);
}
function ReportBrokenLinkDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'brokenLink': json['brokenLink'],
    };
}
function ReportBrokenLinkDtoToJSON(json) {
    return ReportBrokenLinkDtoToJSONTyped(json, false);
}
function ReportBrokenLinkDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'brokenLink': value['brokenLink'],
    };
}
